import { $getNodeByKey } from 'lexical';
import { ProjectMetadataTokenNode } from 'modules/Lexical/nodes/ProjectMetadataTokenNode';
import { ProjectMetadataMapMedcomms, ProjectMetadataTypeMedComms } from 'const/MedComms/ProjectMetadata';

const isAssetNumberMetadataKey = (metadataKey: string): boolean => {
  return metadataKey === ProjectMetadataMapMedcomms[ProjectMetadataTypeMedComms.ASSET_ID].key;
};

export const $updateAssetNumberId = (key: string, assetNumberId: string): void => {
  const node = $getNodeByKey<ProjectMetadataTokenNode>(key);
  if (!node) {
    return;
  }
  if (!isAssetNumberMetadataKey(node.getMetadataKey())) {
    return;
  }
  if (assetNumberId === node.getValue()) {
    return;
  }
  node.setValue(assetNumberId);
  node.switchToViewMode();
};
